<template>
    <div>
        <div id="record-list-field" v-if="showRecordList" height="100%">
            <div v-if="!displayInitialNotice" class="object-titlebox">
                <div class="object-titlebox-left" v-t="'message.title_talkList'"></div>
                <div class="object-titlebox-right" style="padding-top:5px;padding-bottom:5px">
                <span v-if="talkrecords.length == 0">
                    <el-tooltip effect="light" placement="top-start" >
                        <div slot="content" style="text-align:left" v-t="'message.info_no_talk_record_list'"></div>
                        <button class="transparent-button-disabled" type="button"><img style="opacity:0.6" src="../assets/icon_download.svg"/><span v-t="'message.action_talkList_export'"></span></button>
                    </el-tooltip>
                </span>
                    <span v-else>
                    <button class="transparent-button" type="button" v-on:click="exportToCsv()"><img src="../assets/icon_download.svg"/><span class="normal-command-text" v-t="'message.action_talkList_export'"></span></button>
                </span>
                    <el-select v-model="selectedLanguageIndex" style="width:130px;padding-right:15px" @change="handleChangeLanguage()">
                        <div v-for="language in languageList">
                            <div v-if="$i18n.locale == 'ja'">
                                <el-option style="font-size:12px" :label="language.description" :value="language.value"></el-option>
                            </div>
                            <div v-else>
                                <el-option :label="language.description_en" :value="language.value"></el-option>
                            </div>
                        </div>
                    </el-select>
                    <button class="transparent-button" type="button" v-on:click="refreshList()"><img src="../assets/icon_load.svg"/><span class="normal-command-text" v-t="'message.action_talk_refresh'"></span></button>
                </div>
            </div>
            <el-table ref="talkRecordsTable"
                  v-loading="loading" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                  :empty-text="getEmptyTalkRecordText()"
                  :show-header="!displayInitialNotice"
                  :row-class-name="checkHiddenData"
                  :data="talkrecords" :default-sort="{prop: 'startTime', order: 'ascending'}" :max-height="recordListPanelHeight" style="width: 100%" header-row-class-name="talkrecord-header">
                <el-table-column prop="startTime" :label="$t('message.item_talk_start_datetime')" sortable width="170">
                    <template slot-scope="scope">
                        {{ scope.row.startTime.toLocaleString() }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('message.item_talk_talker')" prop="displayName" sortable :sort-method="sortByDisplayName" header-align=left align=left width="130">
                    <template slot-scope="scope">
                        <span v-if="scope.row.displayName != null">
                            <span v-if="scope.row.displayName.length <=8">{{ scope.row.displayName }}</span>
                            <span v-else>{{ scope.row.displayName.substring(0,8) }}...</span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('message.item_type')" prop="type" header-align=left align=left width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == Const.TALK_RECORD_VOICE" v-t="'message.item_type_voice'"/>
                        <span v-else-if="isVideo(scope.row.type, scope.row.data)" v-t="'message.item_type_video'"/>
                        <span v-else-if="isImage(scope.row.type, scope.row.data)" v-t="'message.item_type_image'"/>
                        <span v-else-if="scope.row.type == Const.TALK_RECORD_TEXT" v-t="'message.item_type_text'"/>
                        <span v-else-if="scope.row.isMml" v-t="'message.item_type_melody_stamp'"/>
                        <span v-else v-t="'message.item_type_etc'"/>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('message.item_talk_text')" prop="data" header-align=left align=left>
                    <template slot-scope="scope">
                        <span v-if="scope.row.data != null && ((scope.row.type == Const.TALK_RECORD_VOICE) || (scope.row.type == Const.TALK_RECORD_TEXT) || (scope.row.type == Const.TALK_RECORD_ONLOAD_DATA))">
                            <span v-if="scope.row.data.length <= 16">{{ scope.row.data }}</span>
                            <span v-else>{{ scope.row.data.substring(0,16) }}...</span>
                        </span>
                        <span v-else>
                            －
                        </span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('message.action_talk_play')" header-align=center align=center width="65">
                    <template slot-scope="scope">
                        <button v-if="scope.row.type == Const.TALK_RECORD_VOICE" class="item-record-button" @click="clickPlay(scope.row, $event)">
                            <img src="../assets/icon_start.svg"></img>
                        </button>
                        <button v-if="scope.row.type == Const.TALK_RECORD_BINARY" class="item-record-button" @click="getBinaryData(scope.row)">
                            <img src="../assets/icon_start.svg"></img>
                        </button>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('message.item_talk_time')" prop="duration" header-align=left align=left　width="85">
                    <template slot-scope="scope">
                        <span v-if="scope.row.duration != null && ((scope.row.type == Const.TALK_RECORD_VOICE) || isVideo(scope.row.type, scope.row.data))">
                            <span>{{ convertMillsec(scope.row.duration) }}</span>
                        </span>
                        <span v-else>
                            －
                        </span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('message.action_talk_detail')" header-align=center align=center width="65">
                    <template slot-scope="scope">
                        <button class="item-record-button" @click="showDetailWindow(scope.row)">
                            <img src="../assets/icon_detail.svg"></img>
                        </button>
                    </template>
                </el-table-column>
            </el-table>
            <div v-if="displayInitialNotice" height="100%">
                <td colspan="5" align="center" class="notalkrecord">
                    <div v-if="this.selected.length == 0">
                        <span v-html="$t('message.hint_menu_talkHistory1')"></span>
                        <br>
                        <hr class="hint-hr">
                        <br>
                        <table  class="hint-table" align="center">
                            <tr>
                                <td class="hint-table-title" v-t="'message.hint_menu_talkHistory2'"></td>
                            </tr>
                            <tr>
                                <td class="hint-table-item" v-t="'message.hint_menu_talkHistory3'"></td>
                            </tr>
                            <tr>
                                <td class="hint-table-title" v-t="'message.hint_menu_talkHistory4'"></td>
                            </tr>
                            <tr>
                                <td class="hint-table-item" v-t="'message.hint_menu_talkHistory5'"></td>
                            </tr>
                        </table>
                    </div>
                </td>
            </div>
        </div>
        <audio id="record-player">
            <source v-bind:src="playSource" type="audio/ogg"></source>
        </audio>

        <talkrecord-detail
            v-if="showDetail"
            v-bind:record="detailShownRecord" :selected=this.selected :isTalkgroup=this.isTalkgroup
            @cancel="showDetail=false">
        </talkrecord-detail>
        <VideoPlayer v-if="showVideoPlayer" :playVideoSrc="playVideoSrc" @close="showVideoPlayer=false"></VideoPlayer>
        <ImageViewer v-if="showImageViewer" :imageSrc="imageSrc" @close="showImageViewer=false"></ImageViewer>
     </div>
</template>

<script>
import server from "./ServerApi.js";
import TalkrecordDetail from "./TalkrecordDetail.vue"
import commonUtil from './commonutil.js';
import constants from './constants.js';
import VideoPlayer from "./VideoPlayer.vue"
import ImageViewer from "./ImageViewer.vue"

export default {
    data() {
        return {
            Const: {
                TALK_RECORD_VOICE: constants.TALK_RECORD_VOICE,
                TALK_RECORD_TEXT:  constants.TALK_RECORD_TEXT,
                TALK_RECORD_BINARY: constants.TALK_RECORD_BINARY,
                TALK_RECORD_ONLOAD_DATA: constants.TALK_RECORD_ONLOAD_DATA
            },
            showVideoPlayer: false,
            showImageViewer: false,
            showRecordList: true,
            notSupportAgent: false,
            talkrecords: [],
            playSource: '',
            showDetail: false,
            detailShownRecord: null,
            languageList: null,
            selectedLanguageIndex: 0,
            playVideoSrc: null,
            imageSrc: null,
            timer: null,
            loading: false,
            displayInitialNotice: true,
        };
    },
    methods: {
        initTalkRecordListPanel: function() {
            this.currentPlayingButton = null;
            this.languageList = commonUtil.getLanguageIndexList(this.$i18n.locale);
            this.selectedLanguageIndex = this.languageIndex;
            this.displayInitialNotice = true;
        },
        getList: function(refresh) {
            let audio = document.getElementById('record-player');
            audio.pause();

            if (!isNaN(audio.duration)) {
                // error occurred if access to currentTime before meta data of audio is loaded on IE11.
                audio.currentTime = 0;
            }

            if (this.selected.length === 0) {
                this.talkrecords = [];
                return;
            }

            if (!this.isTalkgroup && this.selected.length !== 2) {
                this.talkrecords = [];
                return;
            }

            let self = this;

            let localFromTime = this.startTime.split(':')
            let localToTime = this.endTime.split(':')
            let localFromDate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), localFromTime[0], localFromTime[1]);
            let localToDate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), localToTime[0], localToTime[1]);

            let utcFromDateStr = localFromDate.toISOString();
            let utcToDateStr = localToDate.toISOString();

            let endpoint;
            let input;

            this.loading = true;
            this.displayInitialNotice = false;

            if (this.isTalkgroup) {
                endpoint = '/gettalkrecords';
                input = {
                    talkgroupId: this.selected[0].data.id,
                    fromDate: utcFromDateStr,
                    toDate: utcToDateStr,
                    interestLanguageIndex: this.selectedLanguageIndex
                }
            } else {
                endpoint = '/getpeertalkrecords';
                input = {
                    userId1: this.selected[0].data.id,
                    userId2: this.selected[1].data.id,
                    fromDate: utcFromDateStr,
                    toDate: utcToDateStr,
                    interestLanguageIndex: this.selectedLanguageIndex
                }
            }

            server.post(endpoint, input)
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            this.talkrecords = this.mergeTalkrecords(res.data.talkRecords, self.selectedLanguageIndex);
                            self.setTimer();
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            this.talkrecords = [];
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_refresh_talk_list"));
                            self.loading = false;
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getList").replace("{code}",res.data.status));
                            self.loading = false;
                            return;
                    }
                    if (refresh) {
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_refresh_talk_list"));
                    }
                })
                .catch( function ( error ) {
                    self.loading = false;
                    commonUtil.putExceptionErrorMessage(self, "getList", error);
                });
        },
        refreshList: function() {
            return this.getList(false);
        },
        mergeTalkrecords(talkrecords, interestLanguageIndex) {
            let mergedTalkrecords = [];

            if (talkrecords.length == 0) {
                return mergedTalkrecords;
            }

            let id = talkrecords[0].id;
            let startTime = new Date(talkrecords[0].startTime);
            let displayName = talkrecords[0].displayName;
            let otherLanguages = [];
            let duration = null;
            let type = talkrecords[0].type;  // Voice + Text : 0, Blob : 2, Code : 3, Max : 4
            let data = null;
            let isMml = false;
            let hidden = talkrecords[0].hidden;

            for (let i = 0; i < talkrecords.length; i++) {
                let talkrecord = talkrecords[i];
                if ((talkrecord.type != constants.TALK_RECORD_VOICE) && (talkrecord.type != constants.TALK_RECORD_TEXT) && (talkrecord.type != constants.TALK_RECORD_BINARY) && (talkrecord.type != constants.TALK_RECORD_ONLOAD_DATA)) {
                    continue;
                }
                if (id != talkrecord.id) {
                    mergedTalkrecords.push({
                        id: id,
                        startTime: startTime,
                        displayName: displayName,
                        interestLanguageIndex: interestLanguageIndex,
                        otherLangages: otherLanguages,
                        duration: duration,
                        type: type,
                        data: data,
                        isMml: isMml,
                        hidden: hidden,
                    })
                    startTime = new Date(talkrecord.startTime);
                    displayName = talkrecord.displayName;
                    otherLanguages = [];
                    duration = null;
                    type = talkrecord.type;
                    data = talkrecord.data;
                    hidden = talkrecord.hidden;
                }

                id = talkrecord.id;

                // update isMml if condition met
                isMml = false;
                switch (talkrecord.type) {
                    case constants.TALK_RECORD_VOICE: // Voice
                        duration = talkrecord.duration;
                        type = talkrecord.type;
                        break;
                    case constants.TALK_RECORD_TEXT: // Text
                        if (talkrecord.languageIndex === interestLanguageIndex) {
                            data = talkrecord.data;
                        } else {
                            otherLanguages.push(talkrecord.languageIndex);
                        }
                        break;
                    case constants.TALK_RECORD_ONLOAD_DATA: // Onload data
                        let splitted = talkrecord.data.split(':');
                        isMml = (splitted[0].toUpperCase() == 'MML');
                        data = splitted[1].split('"').join("'");
                        break;
                    case constants.TALK_RECORD_BINARY: // Video
                        if (this.isVideo(talkrecord.type, talkrecord.data)) {
                            duration = talkrecord.duration;
                            data = talkrecord.data;
                            type = talkrecord.type;
                        }
                        break;
                    default:
                        data = talkrecord.data;
                        type = talkrecord.type;
                }
            }

            mergedTalkrecords.push({
                id: id,
                startTime: startTime,
                displayName: displayName,
                interestLanguageIndex: interestLanguageIndex,
                otherLangages: otherLanguages,
                duration: duration,
                type: type,
                data: data,
                isMml: isMml,
                hidden: hidden,
            })
            return mergedTalkrecords;
        },
        clickPlay(talkrecord, event) {
            let img = event.target
            let audio = document.getElementById('record-player');

            if (this.notSupportAgent) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_not_support_play_talk"));
                return;
            }

            if (this.currentPlayingButton !== null) {
              audio.pause();
                if (!isNaN(audio.duration)) {
                    audio.currentTime = 0;
                }
              if (this.currentPlayingButton === event.target) {
                return ;
              }
            }

            let self = this;
            let endpoint;
            let input;
            if (this.isTalkgroup) {
                endpoint = '/geturl';
                input = {
                    talkgroupId: this.selected[0].data.id,
                    recordInfoList: [
                        { id: talkrecord.id, type: talkrecord.type }
                    ],
                }
            } else {
                endpoint = '/getpeerurl';
                input = {
                    userId1: this.selected[0].data.id,
                    userId2: this.selected[1].data.id,
                    recordInfoList: [
                        { id: talkrecord.id, type: talkrecord.type }
                    ],
                }
            }

            server.post(endpoint, input)
                .then((res) => {
                    if(res.data.status != 0){
                        switch (res.data.status) {
                            case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_play_hidden_data"));
                                break;
                            case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"info_no_speech_data"));
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","clickPlay").replace("{code}",res.data.status));
                                break;
                        }
                        return;
                    }

                    img.src = require('../assets/icon_stop.svg')
                    self.currentPlayingButton = event.target;

                    // talkgroup: new specification using urlList
                    // p2p: old specification using urls
                    audio.src = res.data.urlList[0].url;
                    audio.play();
                    audio.addEventListener("pause", function(){
                        self.currentPlayingButton = null;
                        img.src = require('../assets/icon_start.svg')
                    }, false);
                    audio.addEventListener("ended", function(){
                        self.currentPlayingButton = null;
                        img.src = require('../assets/icon_start.svg')
                    }, false);
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "clickPlay", error);
                });
        },
        getBinaryData(talkrecord) {
            this.loadingScreen = this.$loading({
                    lock: true ,
                    text: 'Preparing the data ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0)'
            });
            let self = this;
            let endpoint;
            let input;
            if (this.isTalkgroup) {
                endpoint = '/geturl';
                input = {
                    talkgroupId: this.selected[0].data.id,
                    recordInfoList: [
                        { id: talkrecord.id, type: talkrecord.type }
                    ]
                }
            } else {
                endpoint = '/getpeerurl';
                input = {
                    userId1: this.selected[0].data.id,
                    userId2: this.selected[1].data.id,
                    recordInfoList: [
                        { id: talkrecord.id, type: talkrecord.type }
                    ],
                }
            }

            server.post(endpoint, input)
                .then((res) => {
                    if(res.data.status != 0){
                        switch (res.data.status) {
                            case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_play_hidden_data"));
                                break;
                            case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"info_no_video_data"));
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getBinaryData").replace("{code}",res.data.status));
                                break;
                        }
                        self.closeLoadingScreen();
                        return;
                    }
                    self.closeLoadingScreen();
                    if (self.isVideo(talkrecord.type, talkrecord.data)) {
                        self.playVideoSrc = res.data.urlList[0].url;
                        self.showVideoPlayer = true;
                    } else {
                        self.imageSrc = res.data.urlList[0].url;
                        self.showImageViewer = true;
                    }
                })
                .catch( function ( error ) {
                    self.closeLoadingScreen();
                    commonUtil.putExceptionErrorMessage(self, "getBinaryData", error);
                });
        },
        getEmptyTalkRecordText() {
            if (this.displayInitialNotice) {
                return " ";
            } if ((this.selected === null) || (this.selected.length === 0)) {
                return commonUtil.getMessageText(this.$i18n,"info_please_select_group_or_talkers");
            } else {
                if (this.isTalkgroup) {
                    return commonUtil.getMessageText(this.$i18n,"info_group_talk_not_found");
                } else {
                    if (this.selected.length < 2) {
                        return commonUtil.getMessageText(this.$i18n,"info_please_select_talkers");
                    } else {
                        return commonUtil.getMessageText(this.$i18n,"info_individual_talk_not_found");
                    }
                }
            }
        },
        checkHiddenData({row}){
            if (row.hidden){
                return 'hiddenData-row';
            }else{
                return 'showData-row';
            }
        },
        exportToCsv() {
            let universalBOM = "\uFEFF";
            let csvData = commonUtil.getMessageText(this.$i18n,"title_csv_talkList_notice");
            csvData += commonUtil.getMessageText(this.$i18n,"title_csv_talkList_header");
            for (let talkrecord of this.talkrecords) {
                csvData += commonUtil.getFormattedLocalDatetime(talkrecord.startTime) + ",";
                if (talkrecord.type == constants.TALK_RECORD_VOICE || this.isVideo(talkrecord.type, talkrecord.data)) {
                    csvData += (talkrecord.duration/1000) + ",";
                } else {
                    csvData += "N/A,";
                }
                csvData += talkrecord.displayName + ",";
                switch(talkrecord.type) {
                    case constants.TALK_RECORD_VOICE:
                        csvData += commonUtil.getMessageText(this.$i18n,"item_type_voice") + ",";
                        break;
                    case constants.TALK_RECORD_TEXT:
                        csvData += commonUtil.getMessageText(this.$i18n,"item_type_text") + ",";
                        break;
                    case constants.TALK_RECORD_BINARY:
                        if (this.isVideo(talkrecord.type, talkrecord.data)) {
                            csvData += commonUtil.getMessageText(this.$i18n,"item_type_video") + ",";
                        } else {
                            csvData += commonUtil.getMessageText(this.$i18n,"item_type_image") + ",";
                        }
                        break;
                    case constants.TALK_RECORD_ONLOAD_DATA:
                        if (talkrecord.isMml) {
                            csvData += commonUtil.getMessageText(this.$i18n,"item_type_melody_stamp") + ",";
                        } else {
                            csvData += commonUtil.getMessageText(this.$i18n,"item_type_etc") + ",";
                        }
                        break;
                }
                if (talkrecord.data == null || talkrecord.type == constants.TALK_RECORD_BINARY) {
                    csvData += '"N/A"';
                } else {
                    csvData += '"' + talkrecord.data.split('"').join("'") + '"';
                }
                csvData += "\n";
            }
            let blob = new Blob([universalBOM + csvData], { type: 'application/csv;charset=UTF-8' })
            let downloadFileName = "talkRecordList.csv"
            commonUtil.downloadFile(blob, downloadFileName)
        },
        handleChangeLanguage() {
            if (this.talkrecords.length > 0) {
                this.getList(false);
            }
        },
        isVideo(type, data) {
            return commonUtil.isVideo(type, data);
        },
        isImage(type, data) {
            return commonUtil.isImage(type, data);
        },
        showDetailWindow(talkrecord) {
            this.showDetail = true;
            this.detailShownRecord = talkrecord;
        },
        getDisplayDatetime(utcTime) {
            commonUtil.getFormattedLocalDatetime(utcTime);
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        checkTalkRecordList() {
            console.log(this.$refs.talkRecordsTable.data.length)
            if (this.$refs.talkRecordsTable.data.length === this.talkrecords.length) {
                clearInterval(this.timer);
                this.timer = null;
                this.loading = false;
                commonUtil.notifyMessage(this,"Success",commonUtil.getMessageText(this.$i18n,"info_refresh_talk_list"));
            }
        },
        setTimer: function() {
            if (this.timer != null) {
                clearInterval(this.timer);
                this.timer = null;
            }
            this.timer = setInterval(this.checkTalkRecordList, 100);
        },
        convertMillsec: function(duration) {
            return commonUtil.convertMillsec(duration);
        },
    },
    watch: {
        date: {
            handler(newVal, oldVal) {
                return this.getList(false);
            }
        },
        startTime: {
            handler(newVal, oldVal) {
                return this.getList(false);
            }
        },
        endTime: {
            handler(newVal, oldVal) {
                return this.getList(false);
            }
        },
        selected: {
            handler(newVal, oldVal) {
                return this.getList(false);
            }
        },
        languageIndex: {
            handler(newVal, oldVal) {
               this.selectedLanguageIndex = newVal;
               return this.getList(false);
            }
        },
        recordListPanelHeight(newVal) {
            this.showRecordList = false;
            this.$nextTick(() => {
                 this.showRecordList = true
            })
        },
        '$route' (to, from) {
            if (to.name === "Talk") {
                this.initTalkRecordListPanel();
            }
        }
    },
    created () {
        this.currentPlayingButton = null;
        let userAgent = window.navigator.userAgent.toLowerCase();
        if ((userAgent.indexOf('msie') > 0 ) || (userAgent.indexOf('trident') > 0 )) {
            this.notSupportAgent = true;
        }
        this.languageList = commonUtil.getLanguageIndexList(this.$i18n.locale);
        this.selectedLanguageIndex = this.languageIndex;
    },
    components: {
        VideoPlayer,
        ImageViewer,
        TalkrecordDetail
    },
    props: [ 'appData', 'date', 'startTime', 'endTime', 'languageIndex', 'selected', 'isTalkgroup' , 'recordListPanelHeight' ]
}

</script>

<style>
tr.talkrecord-header > th {
    color: #848991;
    font-size: 12px;
    background-color: #f6f6f6;
    padding-top: 0px;
    padding-bottom: 0px;
}
tr.hiddenData-row {
    background: #cfcfcf;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: unset;
}
tr.hiddenData-row {
    background: #dddddd;
}
tr.hiddenData-row:hover {
    background-color: #cfcfcf;
}
tr.showData-row {
    background: #ffffff;
}
tr.showData-row:hover {
    background-color: #ecf1fa;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
table {
    border-collapse: collapse;
}
tr.talk-record {
    border-bottom: 1px solid #eee;
}
tr.talk-record {
    border-bottom: solid;
    border-width: 1px;
    border-color: #eee;
    padding-left: 20px;
}
td.record-starttime {
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}
td.record-displayname {
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}
td.record-data {
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}
.notalkrecord {
    display: block;
    width: 100%;
    padding-top: 10vh;
    opacity: 0.6;
}
.talkrecord-header {
    width: 100%;
    display: table-row;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
    background-color: #f6f6f6;
}
.talkrecord-header-item {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
}
.object-titlebox-right >>> .el-select .el-input {
    font-size: 12px;
    width: 130px;
}
.object-titlebox-right >>> .el-input__inner {
    height: 30px;
}
.object-titlebox-right >>> .el-input__icon {
    line-height: 30px;
}
.el-table:before {
    background-color: #ffffff;
}
.el-table >>> .cell {
    word-break: normal;
}
</style>
